import type { GetStaticProps } from 'next'
import type { FC } from 'react'
import type { Category, Post } from '@/types'

import { Seo } from '@/components/generals/seo'
import { SiteLayout } from '@/components/layout/site-layout'
import { GoldCta } from '@/components/products'

import {
    BlackBlogCard,
    BlogGridCard,
    ClassicBlogCard,
    FeaturedBlogCard
} from '@/components/blog'

import { getLayoutData } from '@/lib/layout-data'
import { getPosts } from '@/lib/collections'

interface BlogProps {
    categories: Category[]
    posts: Post[]
}

const Blog: FC<BlogProps> = ({ categories, posts }) => {
    const featured = posts[0]
    const black = posts[1]
    const classic = posts.slice(2, 5)
    const more = posts.slice(5)

    return (
        <SiteLayout categories={categories}>
            <Seo title="Blog" />

            <div className='section'>
                <div className='container nav-ignore'>
                    <div className='animation-on-load-01'>
                        <h2 className='accent-text-color'>Recent News</h2>
                    </div>
                    <div className='animation-on-load-02'>
                        <div className='blog-featured-wrapper w-dyn-list'>
                            <div role='list' className='w-dyn-items'>
                                {featured && (
                                    <div role='listitem' className='w-dyn-item'>
                                        <FeaturedBlogCard post={featured} />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className='animation-on-load-02'>
                        <div className='w-layout-grid blog-grid-container'>
                            <div id='w-node-a9c3415c-c152-292c-c3eb-d7483956d989-3731ce4d' className='content'>
                                <div className='w-dyn-list'>
                                    <div role='list' className='w-dyn-items'>
                                        {black && (
                                            <div role='listitem' className='w-dyn-item'>
                                                <BlackBlogCard post={black} />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div id='w-node-_3257b22b-32a3-12b2-3202-b842cac3aff7-3731ce4d' className='content'>
                                <div className='classic-blog-list-wrapper w-dyn-list'>
                                    <div role='list' className='classic-blog-list w-dyn-items'>
                                        {classic.map((post) => (
                                            <ClassicBlogCard key={post.slug} post={post} />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='section grey-section'>
                <div className='container _6ems'>
                    <h3>More News</h3>
                    <div className='blog-grid-wrapper w-dyn-list'>
                        <div role='list' className='blog-grid w-dyn-items'>
                            {more.map((post) => (
                                <BlogGridCard key={post.slug} post={post} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <GoldCta />
        </SiteLayout>
    )
}

export const getStaticProps: GetStaticProps<BlogProps> = async () => {
    const { categories } = getLayoutData()

    return {
        props: {
            categories,
            posts: getPosts()
        }
    }
}

export default Blog
